<template>
<div ref="ShowSetting" id="ShowSetting">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">系统信息设置</span>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="cannelSelect">取消锚点定位</el-button>
        <!-- <el-button type="del" @click="GoBack" v-if="rollbackname!=''">返回历史板块</el-button> -->
        </div>
    </div>
    <div>

        <!-- 小程序模块设置 -->
        <div class="TTL-form-submit-box">
            <span class="TTL-form-submit-title"><i></i><p>宠物设置</p></span>
            <div :class="param.xcx_cate_setting.isselect ? 'TTL-form-submit-content content-select' : 'TTL-form-submit-content' " ref="xcx_cate_setting">
                <span class="TTL-form-content-sub width200">小程序自定义分类</span>
                <div class="TTL-switch width100"><el-switch v-model="param.xcx_cate_setting.value" @change="ChangeSetting('xcx_cate_setting',param.xcx_cate_setting.value)" /></div>
                <div class="TTL-button TTL-btn-option">
                <el-button @click="editPetCate" v-if="param.xcx_cate_setting.value">编辑分类</el-button>
                </div>
            </div>
        </div>

    </div>
</div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_SETTING from '@/Interface/Shop/setting';
export default {
    components: {},
    data() {
        return {
           rollbackname:'',
           rollbackurl:'',
           param: {
               'wechat_is_open':{value:false,isselect:false},
               'xcx_cate_setting':{value:false,isselect:false},
           },
        }
    },

    mounted() {
        this.OnloadMethod();
    },

    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetSettingDetails(); //获取小程序详细信息设置
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.GetSettingDetails();   //获取小程序详细信息设置
                this.GoToLabel(data.name);  //锚点定位
                //提取返回参数
                this.rollbackname=data.rollbackname;  
                this.rollbackurl=data.rollbackurl;
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GoToLabel(data.name);            //锚点定位
                //提取返回参数
                this.rollbackname=data.rollbackname;  
                this.rollbackurl=data.rollbackurl;
            }
        },
        

        /** 跳转到指定位置 **/
        GoToLabel(name) {
            this.$refs[name].scrollIntoView({behavior:'smooth',block:'center'});
            this.param[name].isselect=true;
        },


        /** 取消选中的锚点 **/
        cannelSelect() {
            for(var key in this.param) 
            this.param[key].isselect=false;
        },


        /** 修改模块数据设置 **/
        ChangeSetting(label,value) {
            if(value==true) {value=1}else if(value==false) {value=0;}
            INTERFACE_SETTING.UPDATE_SETTING({label:label,value:value}).then((res) => {
                if(res.status > 0) return false;
            });
        },


        /////////////////////////////////////////
        /////////////////////////////////////////
        //基础操作
        
        /** 获取账号设置信息详情 **/
        GetSettingDetails() {
            var obj=document.getElementById("ShowSetting");
            this.$loading.openloading(obj);
            INTERFACE_SETTING.GET_SETTING_DETAILS().then((res) => {
                if(res.status > 0) return false;
                var result=res.data;
                this.$loading.closeloading(obj);

                //小程序设置
                this.param.wechat_is_open.value=result.wechat_is_open==1 ? true : false;
                this.param.xcx_cate_setting.value=result.xcx_cate_setting==1 ? true : false;
            });
        },


        /** 返回历史组件 **/
        GoBack() {
            var navinfo={name:this.rollbackname,labelentry:this.rollbackurl,components:this.rollbackurl,isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理

            //清空历史返回组件信息
            this.rollbackname='';
            this.rollbackurl='';
        },

        //基础操作
        /////////////////////////////////////////
        /////////////////////////////////////////

        //跳转至编辑小程序宠物分类信息
        editPetCate() {
            var navinfo={name:'编辑小程序宠物分类',labelentry:'EditXcxPetCate',components:'EditXcxPetCate',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },

}
</script>
<style lang="scss" Scoped>
.TTL-form-submit-title {font-size:13px;letter-spacing: 1px;padding:20px 0;border-bottom:1px solid #F2F6FC;display:inline-block;width:100%;position: relative;}
.TTL-form-submit-title i {position: absolute;width:10px;height:40%;background-color: #666eeb;top:30%;border-radius: 6px;}
.TTL-form-submit-title p {margin-left:20px;}
.TTL-form-submit-content {display: inline-flex;align-items: center;width:calc(100% - 100px);padding:20px 50px;font-size:13px;color:#666666;transition:.5s all;}
.content-select {
    background-image: url(@/assets/icon/jiantou.png);
    background-repeat: no-repeat;
    background-size: 18px;
    background-position: 20px center;
    background-color: #DCDFE6;
    border-radius: 6px;
}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-form-content-sub {margin-right:20px;font-size: 13px;line-height: 21px;letter-spacing: 1px;}
</style>